import Severity$1 from '../../../base/common/severity.js';
import { localizeWithPath } from '../../../nls.js';
const _moduleId = "vs/platform/markers/common/markers";
var MarkerSeverity;
( ((function(MarkerSeverity) {
    MarkerSeverity[MarkerSeverity["Hint"] = 1] = "Hint";
    MarkerSeverity[MarkerSeverity["Info"] = 2] = "Info";
    MarkerSeverity[MarkerSeverity["Warning"] = 4] = "Warning";
    MarkerSeverity[MarkerSeverity["Error"] = 8] = "Error";
})(MarkerSeverity || (MarkerSeverity = {}))));
( ((function(MarkerSeverity) {
    function compare(a, b) {
        return b - a;
    }
    MarkerSeverity.compare = compare;
    const _displayStrings = Object.create(null);
    _displayStrings[MarkerSeverity.Error] = ( localizeWithPath(_moduleId, 0, "Error"));
    _displayStrings[MarkerSeverity.Warning] = ( localizeWithPath(_moduleId, 1, "Warning"));
    _displayStrings[MarkerSeverity.Info] = ( localizeWithPath(_moduleId, 2, "Info"));
    function toString(a) {
        return _displayStrings[a] || '';
    }
    MarkerSeverity.toString = toString;
    function fromSeverity(severity) {
        switch (severity) {
            case Severity$1.Error: return MarkerSeverity.Error;
            case Severity$1.Warning: return MarkerSeverity.Warning;
            case Severity$1.Info: return MarkerSeverity.Info;
            case Severity$1.Ignore: return MarkerSeverity.Hint;
        }
    }
    MarkerSeverity.fromSeverity = fromSeverity;
    function toSeverity(severity) {
        switch (severity) {
            case MarkerSeverity.Error: return Severity$1.Error;
            case MarkerSeverity.Warning: return Severity$1.Warning;
            case MarkerSeverity.Info: return Severity$1.Info;
            case MarkerSeverity.Hint: return Severity$1.Ignore;
        }
    }
    MarkerSeverity.toSeverity = toSeverity;
})(MarkerSeverity || (MarkerSeverity = {}))));
var IMarkerData;
( ((function(IMarkerData) {
    const emptyString = '';
    function makeKey(markerData) {
        return makeKeyOptionalMessage(markerData, true);
    }
    IMarkerData.makeKey = makeKey;
    function makeKeyOptionalMessage(markerData, useMessage) {
        const result = [emptyString];
        if (markerData.source) {
            result.push(markerData.source.replace('¦', '\\¦'));
        }
        else {
            result.push(emptyString);
        }
        if (markerData.code) {
            if (typeof markerData.code === 'string') {
                result.push(markerData.code.replace('¦', '\\¦'));
            }
            else {
                result.push(markerData.code.value.replace('¦', '\\¦'));
            }
        }
        else {
            result.push(emptyString);
        }
        if (markerData.severity !== undefined && markerData.severity !== null) {
            result.push(( (MarkerSeverity.toString(markerData.severity))));
        }
        else {
            result.push(emptyString);
        }
        if (markerData.message && useMessage) {
            result.push(markerData.message.replace('¦', '\\¦'));
        }
        else {
            result.push(emptyString);
        }
        if (markerData.startLineNumber !== undefined && markerData.startLineNumber !== null) {
            result.push(( (markerData.startLineNumber.toString())));
        }
        else {
            result.push(emptyString);
        }
        if (markerData.startColumn !== undefined && markerData.startColumn !== null) {
            result.push(( (markerData.startColumn.toString())));
        }
        else {
            result.push(emptyString);
        }
        if (markerData.endLineNumber !== undefined && markerData.endLineNumber !== null) {
            result.push(( (markerData.endLineNumber.toString())));
        }
        else {
            result.push(emptyString);
        }
        if (markerData.endColumn !== undefined && markerData.endColumn !== null) {
            result.push(( (markerData.endColumn.toString())));
        }
        else {
            result.push(emptyString);
        }
        result.push(emptyString);
        return result.join('¦');
    }
    IMarkerData.makeKeyOptionalMessage = makeKeyOptionalMessage;
})(IMarkerData || (IMarkerData = {}))));
export { IMarkerData, MarkerSeverity };
